var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"appendix-name"},[_c('icon-font',{attrs:{"type":_vm.fileIcon}}),_c('span',[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }